import { render, staticRenderFns } from "./agreeMent.vue?vue&type=template&id=f560b658&scoped=true"
import script from "./agreeMent.vue?vue&type=script&lang=js"
export * from "./agreeMent.vue?vue&type=script&lang=js"
import style0 from "./agreeMent.vue?vue&type=style&index=0&id=f560b658&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f560b658",
  null
  
)

export default component.exports